import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Select from 'react-select';
import { apiService } from '../../services/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight, faCircleExclamation, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'libphonenumber-js';
import { AsyncPaginate } from 'react-select-async-paginate';
import AttachmentsSeeker from './JobseekerTabs/AttachmentsSeeker';
import DiscussionsSeeker from './JobseekerTabs/DiscussionsSeeker';
import RecentViewJobsSeeker from './JobseekerTabs/RecentViewJobsSeeker';
import RecentApplyJobsSeeker from './JobseekerTabs/RecentApplyJobsSeeker';
import ActivityTimeline from './JobseekerTabs/ActivityTimeline';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import RaisedCasesSeekerComp from './JobseekerTabs/RaisedCasesSeekerComp';
function JobseekerFormDetails() {
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const { id } = useParams();
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [maxDate, setMaxDate] = useState('');
    useEffect(() => {
        const today = dayjs();
        setMaxDate(today.format('YYYY-MM-DD'));
    }, []);
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(true);
    const [showsPassfield, setPassfieldshows] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [passwordVisible3, setPasswordVisible3] = useState(false);
    const [activeTab, setActiveTab] = useState("attachments");
    const [opendataUsc, setOpendataUsc] = useState(false);
    const hasSeekerEdit = sessionStorage.getItem('seekerEdit');
    const [editMode, setEditMode] = useState(hasSeekerEdit || false);
    const [loading, setLoading] = useState(true);
    const [profiles, setProfile] = useState([]);
    const [profiles2, setProfile2] = useState([]);
    const [profiles3, setProfile3] = useState([]);
    const [profiles4, setProfile4] = useState([]);
    const [profiles5, setProfile5] = useState([]);
    const [submitloader, setSubmitloader] = useState(false);
    const [formData, setFormData] = useState({
        request_type:'correct_my_profile',
        details:'',
        first_name: '',
        last_name: '',
        phone_number: '',
        dob: '',
        gender: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        why_enroll: '',
        password: '',
        confirm_password: '',

        citizenship_status: '',
        awaiting_ead_card: '',
        ead_card_applied_date: '',
        citizenship_explanation: '',
        legally_authorized_to_work: '',
        ssn_issue_year: '',
        work_authorization_expiry: '',
        renew_authorization_work:'',
        laws_and_regulations: '',
        i94_copy: null,
        passport_document: null,
        proof_of_work_authorization: null,
        profile: null,

        first_name1: '',
        last_name1: '',
        phone_number1: '',
        relation_type: '',

        referrer_name: '',
        referral_phone_number: '',
        referrer_relationship: '',

        job_title: '',
        industry_start_date: '',
        employment_type: '',
        employee_id: '',
        placement_manager_id: '',
        manager_id: '',
        is_employee: '',

        is_csa: '',
        is_cad: '',
        is_csi: '',
        marketing_risk_level: "",
        linkedin_url: "",
        marketing_email: "",
        marketing_email_pwd: "",
        is_auto_farwards: "",
        marketing_account_recovery_email: "",
        stage: "",
        sub_stage: "",
        is_reset: 0,
        re_onboarding: 0,
    });
    const [training, setTraining] = useState([]);
    const [programStatuses, setProgramStatuses] = useState(
        training.reduce((acc, item) => ({
            ...acc,
            [item.program_id]: item.status
        }), {})
    );
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [relationships, setRelationships] = useState([]);
    const [referrers, setReferrers] = useState([]);
    const [mangerList, setManagerList] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    const [selectedOnManager, setSelectedOnManager] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [citizenshipStatuses, setCitizenshipStatuses] = useState([]);
    const [value, setValue] = useState(dayjs(null));
    const [value1, setValue1] = useState(dayjs(null));
    const [value2, setValue2] = useState(dayjs(null));
    const [value3, setValue3] = useState(dayjs(null));
    const [value4, setValue4] = useState(dayjs(null));
    const [opendata, setOpendata] = useState(false);
    const [opendata2, setOpendata2] = useState(false);
    const [opendata3, setOpendata3] = useState(false);
    const [opendata4, setOpendata4] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [fileNames, setFileNames] = useState({
        passport_document: "",
        i94_copy: "",
        proof_of_work_authorization: "",
        profile: "",
    });
    const [refetchedData, setRefetchedData] = useState({});
    const fetchUserData = useCallback(async () => {
        setLoading(true);
        if(id){
            try {
                const response = await apiService.getRequest(`/admin/jobseeker/${id}`);
                if (response.success === true){
                    setProfile(response.data);
                    if(response.data.immigration_data && response.data.immigration_data.length !== 0){
                        setProfile2(response.data.immigration_data);
                    }
                    if(response.data.emergency_contact && response.data.emergency_contact.length !== 0){
                        setProfile3(response.data.emergency_contact);
                    }
                    if(response.data.referral_info && response.data.referral_info.length !== 0){
                        setProfile4(response.data.referral_info);
                    }
                    if(response.data.user_details && response.data.user_details.length !== 0){
                        setProfile5(response.data.user_details);
                    }
                }else{
                    toast.error("Retry")
                }
                if (response.success === true){
                    const refetchedData = response.data;
                    const immigrationData = response.data.immigration_data;
                    const emergencyconData = response.data.emergency_contact;
                    const referrerData = response.data.referral_info;
                    const userEmployment = response.data.user_details;
                    setRefetchedData(refetchedData);
                    setFormData(prevState => {
                        const updatedFormData = {
                            ...prevState,
                            password:"",
                            confirm_password:"",
                            first_name: refetchedData.first_name || '',
                            last_name: refetchedData.last_name || '',
                            phone_number: refetchedData.phone_number || '',
                            email: refetchedData.email || '',
                            dob: refetchedData.dob || '',
                            gender: refetchedData.gender || '',
                            address: refetchedData.address || '',
                            city: refetchedData.city || '',
                            state: refetchedData.state || '',
                            zipcode: refetchedData.zipcode || '',
                            why_enroll: refetchedData.why_enroll || '',

                            citizenship_status: (immigrationData && immigrationData.citizenship_status) || '',
                            awaiting_ead_card: (immigrationData && immigrationData.awaiting_ead_card) || '',
                            ead_card_applied_date: (immigrationData && immigrationData.ead_card_applied_date) || '',
                            citizenship_explanation: (immigrationData && immigrationData.citizenship_explanation) || '',
                            legally_authorized_to_work: (immigrationData && immigrationData.legally_authorized_to_work) || '',
                            ssn_issue_year: (immigrationData && immigrationData.ssn_issue_year) || '',
                            work_authorization_expiry: (immigrationData && immigrationData.work_authorization_expiry) || '',
                            renew_authorization_work: (immigrationData && immigrationData.renew_authorization_work) || '',
                            laws_and_regulations: true || '',
                            passport_document: (immigrationData && immigrationData.passport_document) ? immigrationData.passport_document : null,
                            i94_copy: (immigrationData && immigrationData.i94_copy) ? immigrationData.i94_copy : null,
                            proof_of_work_authorization: (immigrationData && immigrationData.proof_of_work_authorization) ? immigrationData.proof_of_work_authorization : null,
                            profile: refetchedData.profile ? refetchedData.profile : null,
                            
                            first_name1: (emergencyconData && emergencyconData.first_name) || '',
                            last_name1: (emergencyconData && emergencyconData.last_name) || '',
                            phone_number1: (emergencyconData && emergencyconData.phone_number) || '',
                            relation_type: (emergencyconData && emergencyconData.relation_type) || '',

                            referrer_name: (referrerData && referrerData.referrer_name) || '',
                            referral_phone_number: (referrerData && referrerData.referral_phone_number) || '',
                            referrer_relationship: (referrerData && referrerData.referrer_relationship) || '',

                            is_employee: refetchedData.is_employee || 0,
                            placement_manager_id: userEmployment?.placement_manager_id || null,
                            manager_id: refetchedData.manager_id || null,

                            job_title: (userEmployment && userEmployment.job_title) || '',
                            industry_start_date: (userEmployment && userEmployment.industry_start_date) || '',
                            employment_type: (userEmployment && userEmployment.employment_type) || '',
                            employee_id: (userEmployment && userEmployment.employee_id ) || '',

                            is_csa: (userEmployment?.marketing?.is_csa) || '',
                            is_cad: (userEmployment?.marketing?.is_cad) || '',
                            is_csi: (userEmployment?.marketing?.is_csi) || '',
                            marketing_risk_level: (userEmployment?.marketing?.marketing_risk_level) || '',
                            linkedin_url: (userEmployment?.marketing?.linkedin_url) || '',
                            marketing_email: (userEmployment?.marketing?.marketing_email) || '',
                            marketing_email_pwd: (userEmployment?.marketing?.marketing_email_pwd) || '',
                            is_auto_farwards: (userEmployment?.marketing?.is_auto_farwards) || '',
                            marketing_account_recovery_email: (userEmployment?.marketing?.marketing_account_recovery_email) || '',
                            sub_stage: (userEmployment?.marketing?.sub_stage?.id) || '',
                            stage: (userEmployment?.marketing?.stage?.id) || '',
                            re_onboarding: (userEmployment?.re_onboarding) || 0,
                            is_reset: 0,
                        }
                        if(userEmployment?.marketing?.stage){
                            setSelectedStages({
                                value: userEmployment?.marketing?.stage?.id || null,
                                label: userEmployment?.marketing?.stage?.name || null,
                            });
                        }else{
                            setSelectedStages(null);
                        }
                        if(userEmployment?.marketing?.sub_stage){
                            setSelectedSubStages({
                                value: userEmployment?.marketing?.sub_stage?.id || null,
                                label: userEmployment?.marketing?.sub_stage?.name || null,
                            });
                        }else{
                            setSelectedSubStages(null);
                        }
                        setSelectedState({ 
                            label: refetchedData?.state_name || "", 
                            value: refetchedData?.state_code || "" 
                        });
                        setSelectedCity({ 
                            label: refetchedData?.city,
                            value: refetchedData?.city 
                        });
                        setFileNames({
                            passport_document: (immigrationData && immigrationData.passport_document) ? immigrationData.passport_document.split('/').pop() : '',
                            i94_copy: (immigrationData && immigrationData.i94_copy) ? immigrationData.i94_copy.split('/').pop() : '',
                            proof_of_work_authorization: (immigrationData && immigrationData.proof_of_work_authorization) ? immigrationData.proof_of_work_authorization.split('/').pop() : '',
                            profile: (refetchedData && refetchedData.profile) ? refetchedData.profile.split('/').pop() : ''
                        });
                        handleCitizenshipValidation(updatedFormData); // Custom function for citizenship validation
                        return updatedFormData;
                    });
                    // Set dob
                    if (refetchedData.dob) {
                        const parsedDob = dayjs(refetchedData.dob, 'YYYY-MM-DD');
                        if (parsedDob.isValid()) {
                            setValue(parsedDob); 
                        }
                    }
                    if (userEmployment?.industry_start_date) {
                        const parsedExp = dayjs(userEmployment.industry_start_date, 'YYYY-MM-DD');
                        if (parsedExp.isValid()) {
                            setValue4(parsedExp); 
                        }
                    }
                    if (immigrationData.ead_card_applied_date) {
                        const parsedEad = dayjs(immigrationData.ead_card_applied_date, 'YYYY-MM-DD');
                        if (parsedEad.isValid()) {
                            setValue2(parsedEad); 
                        }
                    }
                    if (immigrationData.work_authorization_expiry) {
                        const parsedWorkexp = dayjs(immigrationData.work_authorization_expiry, 'YYYY-MM-DD');
                        if (parsedWorkexp.isValid()) {
                            setValue1(parsedWorkexp);
                        }
                    }
                    if (immigrationData.ssn_issue_year) {
                        const yearDate = dayjs().year(immigrationData.ssn_issue_year);
                        setValue3(yearDate);
                    }
                    if (userEmployment?.placement_manager_id) {
                        setSelectedManager({ label: userEmployment?.placement_manager, value: userEmployment?.placement_manager_id });
                    }
                    if (refetchedData && refetchedData.manager_id) {
                        setSelectedOnManager({ label: refetchedData?.manager_name, value: refetchedData?.manager_id });
                    }
                    
                }
            } catch (error) {
                console.error("Error fetching user data", error);
            }finally {
                setLoading(false);
            }
        }
    }, [id]);

    const handleSuspend = async (jobseekerId, isSuspended) => {
        setSubmitloaderCase(true);
        try {
            const response = await apiService.postRequest(`/admin/jobseeker/${jobseekerId}/suspend`);
            if(response?.success === true){
                if (isSuspended) {
                    toast(response?.message || "Jobseeker Unsuspended successfully!");
                } else {
                    toast(response?.message || "Jobseeker Suspended successfully!");
                }
                fetchUserData();
            }else{
                toast.error(response?.message || "Failed try again!");
            }
        } catch (err) {
            console.log(err);
        }finally{
            setSubmitloaderCase(false);
            handleCloseCase();
        }
    };
    const handleRecycle = async (jobseekerId) => {
        setSubmitloaderCase2(true);
        try {
            const response = await apiService.getRequest(`admin/jobseeker/move-to-recycle-stage/${jobseekerId}`);
            if(response?.success === true){
                toast(response?.message ||"Jobseeker moved to recycle stage successfully!");
                fetchUserData();
            }else {
                toast.error(response?.message || "Failed try again!");
            }
        } catch (err) {
            console.log(err);
        }finally{
            setSubmitloaderCase2(false);
            handleCloseCase2();
        }
    };
    const handleOnboard = async (jobseekerId) => {
        setSubmitloaderCase3(true);
        try {
            const response = await apiService.postRequest(`admin/jobseeker/force_onboarded/${jobseekerId}`);
            if(response?.success === true){
                toast(response?.message ||"Updated Successfully!");
                fetchUserData();
            }else {
                toast.error(response?.message || "Failed try again!");
            }
        } catch (err) {
            console.log(err);
        }finally{
            setSubmitloaderCase3(false);
            handleCloseCase3();
        }
    };

    const [showCasepop, setShowCasepop] = useState(false);
    const [loadingCase, setSubmitloaderCase] = useState(false);
    const [showCasepop2, setShowCasepop2] = useState(false);
    const [loadingCase2, setSubmitloaderCase2] = useState(false);
    const [showCasepop3, setShowCasepop3] = useState(false);
    const [loadingCase3, setSubmitloaderCase3] = useState(false);
    // const [caseActionform, setCaseActionForm] = useState({
    //     status: "",
    //     justification: "",
    // })

    // const handleselectCase = (statussend) => {
    //     setSelectedCaseStatus(statussend);
    //     setShowCasepop(true);
    //     setCaseActionForm((prevData) => ({
    //         ...prevData,
    //         status: statussend,
    //     }));
    // };
    const handleCloseCase = () => setShowCasepop(false);
    const handleCloseCase2 = () => setShowCasepop2(false);
    const handleCloseCase3 = () => setShowCasepop3(false);

    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };
    const togglePasswordVisibility3 = () => {
        setPasswordVisible3(!passwordVisible3);
    };

    const handleCitizenshipValidation = (formData) => {
        const citizenshipStatus = formData.citizenship_status;
        const validationErrors = {};
    
        if (!citizenshipStatus) {
            validationErrors.citizenship_status = ['Citizenship status is required'];
        } else {
            delete validationErrors.citizenship_status;
        }
    
        let openData3 = false;
        let openData4 = false;
        if (formData.legally_authorized_to_work === 'yes' && citizenshipStatus !== 'USC' && citizenshipStatus !== 'GC') {
            openData3 = true;
        } else if (formData.legally_authorized_to_work === 'no') {
            openData4 = true;
        } else {
            formData.work_authorization_expiry = '';
        }
        
        setOpendata3(openData3);
        setOpendata4(openData4);
        if (citizenshipStatus === 'USC' || citizenshipStatus === 'GC') {
            setOpendataUsc(true);
        }else{
            setOpendataUsc(false);
        }
        if (citizenshipStatus === 'OPT EAD' || citizenshipStatus === 'GC EAD' || citizenshipStatus === 'H4 EAD') {
            setOpendata(true);
        } else {
            setOpendata(false);
            setOpendata2(false);
            formData.awaiting_ead_card = '';
            formData.ead_card_applied_date = '';
            delete validationErrors.awaiting_ead_card;
            delete validationErrors.ead_card_applied_date;
        }
    
        if (formData.awaiting_ead_card === 'yes') {
            setOpendata2(true);
        } else {
            setOpendata2(false);
            formData.ead_card_applied_date = '';
            delete validationErrors.ead_card_applied_date;
        }
        const sixMonthsFromNow = dayjs().add(6, 'month');
        // Ensure formData.work_authorization_expiry is a dayjs object
        const workAuthExpiry = dayjs(formData.work_authorization_expiry);

        if (workAuthExpiry.isBefore(sixMonthsFromNow)) {
            setOpendata4(true);
        } else {
            setOpendata4(false);
        }
    };

    useEffect(() => {
        if(editMode === true && id){
            const fetchData = async () => {
                const response = await apiService.postRequest(`admin/jobseeker-training-details/${id}`);
                if (response.success) {
                    setTraining(response.data);

                    // ✅ Add this
                    setProgramStatuses(
                        response.data.reduce((acc, item) => ({
                            ...acc,
                            [item.program_id]: item.status
                        }), {})
                    );
                }
            };
            fetchData();
        }
    }, [editMode, id]);
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.postRequest('generalsettings-data');
            if (response.success) {
                setStates(response.states);
                setCitizenshipStatuses(response.citizenship_statuses);
                setRelationships(response.relationships);
                setReferrers(response.referrers);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        if (formData.state && editMode === true) {
            const fetchData = async () => {
                const response = await apiService.postRequest(`cities/${formData.state}`);
                if (response.success) {
                    setCities(response.data || []);
                    if(formData.state !== profiles?.state){
                        setSelectedCity(null);
                    }
                }
            };
            fetchData();
        }
    }, [formData.state,profiles.state, editMode]);
    useEffect(() => {
        if(id && editMode === true){
            const fetchDataManager = async () => {
                const userParam = {
                    user_id : Number(id)
                }
                const response = await apiService.postRequest(`manager_list`, userParam);
                if (response.success) {
                    setManagerList(response.data || []);
                }
            };
            fetchDataManager();
        }
    }, [id, editMode]);
    const handleDateChange = (newValue) => {
        if (newValue) {
            setValue(newValue);
            setFormData({ ...formData, dob: newValue.format('YYYY-MM-DD') });
    
            // Clear the error for dob if a valid date is entered
            if (errors.dob) {
                setErrors({ ...errors, dob: '' });
            }
        } else {
            setValue(null);
            setFormData({ ...formData, dob: '' }); // Clear the value if null
        }
    };
    const handleDateChange4 = (newValue) => {
        if (newValue) {
            setValue4(newValue);
            setFormData({ ...formData, industry_start_date: newValue.format('YYYY-MM-DD') });
    
            // Clear the error for dob if a valid date is entered
            if (errors.industry_start_date) {
                setErrors({ ...errors, industry_start_date: '' });
            }
        } else {
            setValue4(null);
            setFormData({ ...formData, industry_start_date: '' }); // Clear the value if null
        }
    };
    const handleDateChange1 = (newValue) => {
        if (newValue) {
            setValue2(newValue);
            setFormData({ ...formData, ead_card_applied_date: newValue.format('YYYY-MM-DD') });
    
            // Clear the error for dob if a valid date is entered
            if (errors.ead_card_applied_date) {
                setErrors({ ...errors, ead_card_applied_date: '' });
            }
        } else {
            setValue2(null);
            setFormData({ ...formData, ead_card_applied_date: '' });
        }
    };
    useEffect(() => {
        if (formData.work_authorization_expiry) {
            const newValue = dayjs(formData.work_authorization_expiry, 'YYYY-MM-DD');
    
            if (newValue.isValid()) {
                const sixMonthsFromNow = dayjs().add(6, 'month');
                if (newValue.isBefore(sixMonthsFromNow)) {
                    setOpendata4(true);
                } else {
                    setOpendata4(false);
                    setFormData(prevState => ({
                        ...prevState,
                        renew_authorization_work: '',
                    }));
                }
            }
        } else {
            setOpendata4(false);
        }
    }, [formData.work_authorization_expiry]);
    
    const handleDateChange2 = (newValue) => {
        if (newValue) {
            setValue1(newValue);
            const formattedDate = newValue.format('YYYY-MM-DD');
            setFormData(prevState => ({
                ...prevState,
                work_authorization_expiry: formattedDate,
            }));
    
            if (errors.work_authorization_expiry) {
                setErrors({ ...errors, work_authorization_expiry: '' });
            }
        } else {
            setValue1(null);
            setFormData(prevState => ({
                ...prevState,
                work_authorization_expiry: '',
            }));
            setOpendata4(false); // Reset if the date is cleared
        }
    };
    const handleDateChange3 = (newValue) => {
        if (newValue) {
            setValue3(newValue);
            setFormData({ ...formData, ssn_issue_year: newValue.format('YYYY') });

            if (errors.ssn_issue_year) {
                setErrors({ ...errors, ssn_issue_year: '' });
            }
        } else {
            setValue3(null);
            setFormData({ ...formData, ssn_issue_year: '' });
        }
    };
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            const file = files[0]; // Get the selected file

            // Update the formData state with the new file
            setFormData((prevData) => ({
                ...prevData,
                [name]: file, // Store the file object for submission
            }));
            // Update the fileNames state to show the file name
            setFileNames((prevNames) => ({
                ...prevNames,
                [name]: file.name, // Store the file name for display
            }));
        }
    };
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
    
        // Update the form data state
        if (type === 'radio' || type === 'checkbox') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: (name === "is_employee" || name === "is_cad" || name === "is_csa" ||name === "is_csi" || name === "is_auto_farwards" || name === "is_reset" || name === "re_onboarding")
                    ? (checked ? 1 : 0)
                    : checked,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }

        let validationErrors = { ...errors };
    
        // Validate Citizenship Status
        if (name === 'citizenship_status') {
            if (!value) {
                validationErrors.citizenship_status = ['Citizenship status is required'];
            } else {
                delete validationErrors.citizenship_status;  // Remove error if valid
            }
            
            if (value === 'USC' || value === 'GC') {
                setOpendataUsc(true);
            }else{
                setOpendataUsc(false);
            }

            if (value === 'OPT EAD' || value === 'GC EAD' || value === 'H4 EAD') {
                setOpendata(true);
            } else {
                setOpendata(false);
                setOpendata2(false);
                setFormData(prevData => ({
                    ...prevData,
                    awaiting_ead_card: '',
                    ead_card_applied_date: ''
                }));
                delete validationErrors.awaiting_ead_card;
                delete validationErrors.ead_card_applied_date;
            }
        }
    
        // Validate Awaiting EAD Card
        if (name === 'awaiting_ead_card') {
            if (value === 'yes') {
                setOpendata2(true);
            } else {
                setOpendata2(false);
                setFormData(prevData => ({
                    ...prevData,
                    ead_card_applied_date: ''
                }));
                delete validationErrors.ead_card_applied_date;
            }
        }

        if (name === 'is_employee') {
            if (value === 1) {
                
            } else {
                setValue4(null);
                setSelectedOnManager(null);
                setFormData(prevData => ({
                    ...prevData,
                    job_title: '',
                    industry_start_date: '',
                    employment_type: '',
                    employee_id: ''
                }));
                delete validationErrors.job_title;
                delete validationErrors.industry_start_date;
                delete validationErrors.employment_type;
                delete validationErrors.employee_id;
            }
        }
        if (name === 'employment_type') {
            if (value === "dallas_employee") {
                
            } else {
                setValue4(null);
                setSelectedOnManager(null);
                setFormData(prevData => ({
                    ...prevData,
                    job_title: '',
                    industry_start_date: '',
                    employee_id: ''
                }));
                delete validationErrors.job_title;
                delete validationErrors.industry_start_date;
                delete validationErrors.employee_id;
            }
        }
        // Validate Awaiting EAD Card
    
        // Validate Explanation of Citizenship
        if (name === 'citizenship_explanation') {
            if (!value) {
                validationErrors.citizenship_explanation = ['Please explain your citizenship status'];
            } else {
                delete validationErrors.citizenship_explanation;
            }
        }
    
        // Validate Legal Authorization to Work
        if (name === 'legally_authorized_to_work') {
            if (!value) {
                validationErrors.legally_authorized_to_work = ['Please select if you are legally authorized to work'];
            } else {
                delete validationErrors.legally_authorized_to_work;
            }
        }

        if (name === 'laws_and_regulations') {
            delete validationErrors.laws_and_regulations;
        }
        
        setErrors(validationErrors);
    };
    useEffect(() => {
        if (formData.legally_authorized_to_work === 'yes' && 
            formData.citizenship_status !== 'USC' && 
            formData.citizenship_status !== 'GC') {
            setOpendata3(true);
            setOpendata4(false);
        }else if (formData.legally_authorized_to_work === 'no'){
            setOpendata4(true);
            setOpendata3(false);
        } else {
            setOpendata3(false);
            setOpendata4(false);
            setFormData(prevData => ({
                ...prevData,
                work_authorization_expiry: ''
            }));
        }
    }, [formData.legally_authorized_to_work, formData.citizenship_status]);
    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        handleInputChange({
            target: {
                name: 'state',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        // Clear the city field when state is changed
        setSelectedCity(null);
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption); // Update city
        handleInputChange({
            target: {
                name: 'city',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    
    const handleOnshoreManagerChange = (selectedOption) => {
        setSelectedOnManager(selectedOption);
        handleInputChange({
            target: {
                name: 'manager_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const handleManagerChange = (selectedOption) => {
        setSelectedManager(selectedOption);
        handleInputChange({
            target: {
                name: 'placement_manager_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const handlePhoneNumberChange = (e) => {
        const inputElement = e.target;
        const inputValue = inputElement.value;
        const cursorPosition = inputElement.selectionStart;

        let formattedInput = inputValue.replace(/\D/g, ''); // Remove non-digit characters

        if (formattedInput.length > 3 && formattedInput.length <= 6) {
            formattedInput = formattedInput.replace(/(\d{3})(\d+)/, '($1) $2'); // Format (123) 456
        } else if (formattedInput.length > 6) {
            formattedInput = formattedInput.replace(/(\d{3})(\d{3})(\d+)/, '($1) $2-$3'); // Format (123) 456-7890
        } else if (formattedInput.length <= 3) {
            formattedInput = `(${formattedInput}`; // Start formatting with open bracket (123
        }

        setFormData({ ...formData, phone_number: formattedInput });

        const newCursorPosition = cursorPosition + (formattedInput.length - inputValue.length);
        setTimeout(() => {
            inputElement.selectionStart = newCursorPosition;
            inputElement.selectionEnd = newCursorPosition;
        }, 0);

        // Phone number validation
        let validationErrors = { ...errors };
        if (!formattedInput) {
            validationErrors.phone_number = 'Phone number is required';
        } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formattedInput)) {
            validationErrors.phone_number = 'Phone number must be in the format: (123) 456-7890';
        } else {
            delete validationErrors.phone_number;
        }

        setErrors(validationErrors);
    };
    const handlePhoneNumberChange1 = (e) => {
        const inputElement = e.target;
        const inputValue = inputElement.value;
        const cursorPosition = inputElement.selectionStart;

        let formattedInput = inputValue.replace(/\D/g, ''); // Remove non-digit characters

        if (formattedInput.length > 3 && formattedInput.length <= 6) {
            formattedInput = formattedInput.replace(/(\d{3})(\d+)/, '($1) $2'); // Format (123) 456
        } else if (formattedInput.length > 6) {
            formattedInput = formattedInput.replace(/(\d{3})(\d{3})(\d+)/, '($1) $2-$3'); // Format (123) 456-7890
        } else if (formattedInput.length <= 3) {
            formattedInput = `(${formattedInput}`; // Start formatting with open bracket (123
        }

        setFormData({ ...formData, phone_number1: formattedInput });

        const newCursorPosition = cursorPosition + (formattedInput.length - inputValue.length);
        setTimeout(() => {
            inputElement.selectionStart = newCursorPosition;
            inputElement.selectionEnd = newCursorPosition;
        }, 0);

        // Phone number validation
        let validationErrors = { ...errors };
        if (!formattedInput) {
            validationErrors.phone_number1 = 'Phone number is required';
        } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formattedInput)) {
            validationErrors.phone_number1 = 'Phone number must be in the format: (123) 456-7890';
        } else {
            delete validationErrors.phone_number1;
        }

        setErrors(validationErrors);
    };
    const handlePhoneChange = (value) => {
        if (value) {
            const country = allowedCountries.find(
            (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';
    
            const maxLength = maxPhoneLengths[country];
    
            // Strip the country code and check the actual phone number length
            const phoneWithoutCode = value.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
            
            if (phoneWithoutCode.length <= maxLength) {
            handleInputChange({ target: { name: "referral_phone_number", value } });
            }
        } else {
            handleInputChange({ target: { name: "referral_phone_number", value: '' } });
        }
    };
    const handleKeyDown2 = (event) => {
        const { key } = event;
        const currentValue = formData.referral_phone_number || '';
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';
    
        const maxLength = maxPhoneLengths[country];
    
        // Remove country code and check the actual phone number length
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
    
        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault(); // Stop further input
        }
    };


    const [selectedStages, setSelectedStages] = useState(null);
    const [selectedSubStages, setSelectedSubStages] = useState([]);
    const [optionsKey, setOptionsKey] = useState(0);
    const clearDropdownOptions = () => {
        setOptionsKey(prev => prev + 1);
    };
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page
        }
        try {
        const response = await apiService.postRequest(
            `admin/jobseeker/stages`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const loadOptionsSubtype = async (searchQuery, loadedOptions,  { page }) => {
        const valuesArray = selectedStages.value;
        const params = {
            stage_id: Number(valuesArray),
            search: searchQuery,
            page : page,
        }
        try {
        const response = await apiService.postRequest(
            `admin/jobseeker/sub-stages`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
                page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const handleSubStages = (selectedOptions) => {
        setSelectedSubStages(selectedOptions); 
        
        setFormData((prevFormData) => ({
            ...prevFormData,
            sub_stage: selectedOptions?.value || "",
        }));
        if (errors.sub_stage) {
            setErrors({ ...errors, sub_stage: '' });
        }
    };
    const handleStagesChange = (selectedOptions) => {
        setSelectedStages(selectedOptions); // Update the selected options for display
        setSelectedSubStages([]);
        clearDropdownOptions();
        // const selectedValues = selectedOptions ? selectedOptions.map(option => Number(option.value)) : [];
    
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            stage: selectedOptions?.value || "",
            sub_stage: [] || "",
        }));
        if (errors.stage) {
            setErrors({ ...errors, stage: '' });
        }
    };
    const handleStatusChange = (programId, newStatus) => {
        setProgramStatuses(prev => ({
            ...prev,
            [programId]: newStatus
        }));
    };

    const validate = () => {
        const validationErrors = {};
        // Form 1
        if (!formData.first_name) {
            validationErrors.first_name = 'First name is required';
        }
        if (!formData.last_name) {
            validationErrors.last_name = 'Last name is required';
        }
        if (!formData.phone_number.trim()) {
            validationErrors.phone_number = 'Phone number is required';
        }
        else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone_number1)) {
            validationErrors.phone_number1 = 'Phone number must be in the format: (123) 456-7890';
        }
        if (!formData.dob) {
            validationErrors.dob = ['Date of Birth is required'];
        }
        if (!formData.state) {
            validationErrors.state = ['State is required'];
        }
        if (!formData.city) {
            validationErrors.city = ['City is required'];
        }
        if (!formData.gender) {
            validationErrors.gender = ['Gender is required'];
        }
        if (!formData.address.trim()) {
            validationErrors.address = 'Address is required';
        }
        if (!formData.zipcode.trim()) {
            validationErrors.zipcode = 'Zipcode is required';
        }
        if (formData.zipcode) { // Ensure the field exists before validating
            const zipLength = formData.zipcode.length;
            if (zipLength < 5) {
                validationErrors.zipcode = "Zipcode must be at least 5 characters long";
            } else if (zipLength > 5 && zipLength < 9) {
                validationErrors.zipcode = "Zipcode must be either 5 or at least 9 characters long";
            }
        }
        if(formData.password !== ""){
            if (formData.password !== formData.confirm_password) {
                validationErrors.confirm_password = 'Passwords do not match!';
            }
        }
        if(formData.password !== ""){
            const password = formData.password;
            const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
            if (!passwordFormat.test(password)) {
                validationErrors.password = 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and any one special character.';
            }
        }
        
        // Form 2
        if (!formData.citizenship_status) {
            validationErrors.citizenship_status = ['Citizenship status is required'];
        }
        if (opendata) {
            if (!formData.awaiting_ead_card) {
                validationErrors.awaiting_ead_card = ['Please select if you are awaiting your EAD Card'];
            }
        }
        if (opendata2) {
            if (!formData.ead_card_applied_date) {
                validationErrors.ead_card_applied_date = ['EAD card application date is required'];
            }
        }
        if (!formData.citizenship_explanation) {
            validationErrors.citizenship_explanation = ['Please explain your citizenship status'];
        }
        if (!formData.legally_authorized_to_work) {
            validationErrors.legally_authorized_to_work = ['Please select if you are legally authorized to work'];
        }
        if (!formData.ssn_issue_year) {
            validationErrors.ssn_issue_year = ['SSN issue year is required'];
        }
        if (opendata3) {
            if (!formData.work_authorization_expiry) {
                validationErrors.work_authorization_expiry = ['Work authorization expiry date is required'];
            }
        }
        if (opendata4) {
            if (!formData.renew_authorization_work) {
                validationErrors.renew_authorization_work = ['Work authorization renewal action details is required'];
            }
        }
        

        if(opendataUsc){
            if (!formData.passport_document && typeof formData.passport_document !== 'string') {
                validationErrors.passport_document = ['Passport Copy is required'];
            }
        }
        if(!opendataUsc){
            if (!formData.laws_and_regulations) {
                validationErrors.laws_and_regulations = ['Please confirm the authorization to verify I-94'];
            }
    
        // Check if file fields are null or undefined only (skip strings)
            if (!formData.i94_copy && typeof formData.i94_copy !== 'string') {
                validationErrors.i94_copy = ['I-94 Copy is required'];
            }
        }
        if (!opendata2) {
            if (!formData.proof_of_work_authorization && typeof formData.proof_of_work_authorization !== 'string') {
                validationErrors.proof_of_work_authorization = ['Proof of work authorization is required'];
            }
        }
        // Form 3
        if (!formData.first_name1.trim()) {
            validationErrors.first_name1 = 'First name is required';
        }
        if (!formData.last_name1.trim()) {
            validationErrors.last_name1 = 'Last name is required';
        }
        if (!formData.phone_number1.trim()) {
            validationErrors.phone_number1 = 'Phone number is required';
        }
        else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone_number1)) {
            validationErrors.phone_number1 = 'Phone number must be in the format: (123) 456-7890';
        }
        if (!formData.relation_type) {
            validationErrors.relation_type = 'Relationship is required';
        }
        // Form 4
        if (!formData.referrer_name.trim()) {
            validationErrors.referrer_name = 'Referrer name is required';
        }
        if (!formData.referral_phone_number.trim()) {
            validationErrors.referral_phone_number = 'Phone number is required';
        }
        if (!formData.referrer_relationship) {
            validationErrors.referrer_relationship = 'Referrer relationship is required';
        }

        // Form 5
        if(formData.is_employee === 1){
            if (!formData.employment_type.trim()) {
                validationErrors.employment_type = 'Employment type is required';
            }
            if(formData.employment_type === "dallas_employee"){
                if (!formData.job_title.trim()) {
                    validationErrors.job_title = 'Job title is required';
                }
                if (!formData.employee_id) {
                    validationErrors.employee_id = 'Employee ID is required';
                }
                if (formData.industry_start_date === "") {
                    validationErrors.industry_start_date = 'Industry start date is required';
                }
                if (!formData.manager_id) {
                    validationErrors.manager_id = 'Onshore Manager is required';
                }
            }
        }
        if (!formData.placement_manager_id) {
            validationErrors.placement_manager_id = 'Placement Manager is required';
        }
        return validationErrors;
    };
    useEffect(() => {
    if(showsPassfield !== true){
        setFormData({
            password: '',
            confirm_password: '',
        })
    }
    }, [showsPassfield]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setErrorMessage("");
        setSubmitloader(true);
        try {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setErrorMessage("Please fix the errors before proceeding.");
            return;
        }

        const formDataObj = new FormData();
    
        if (formData.first_name !== refetchedData.first_name) {
            formDataObj.append("first_name", formData.first_name);
        }
        if (formData.last_name !== refetchedData.last_name) {
            formDataObj.append("last_name", formData.last_name);
        }
        if (formData.phone_number !== refetchedData.phone_number) {
            formDataObj.append("phone_number", formData.phone_number);
        }
        if (formData.dob !== refetchedData.dob) {
            formDataObj.append("dob", formData.dob);
        }
        if (formData.gender !== refetchedData.gender) {
            formDataObj.append("gender", formData.gender);
        }
        if (formData.address !== refetchedData.address) {
            formDataObj.append("address", formData.address);
        }
        if (formData.city !== refetchedData.city) {
            formDataObj.append("city", formData.city);
        }
        if (formData.state !== refetchedData.state) {
            formDataObj.append("state", formData.state);
        }
        if (formData.zipcode !== refetchedData.zipcode) {
            formDataObj.append("zipcode", formData.zipcode);
        }
        if (formData.password !== refetchedData.password) {
            formDataObj.append("password", formData.password);
        }
        if (formData.confirm_password !== refetchedData.confirm_password) {
            formDataObj.append("confirm_password", formData.confirm_password);
        }
        if (formData.profile !== refetchedData.profile) {
            formDataObj.append("profile", formData.profile);
        }
        
        // Immigration data check and append
        if (formData.citizenship_status !== refetchedData.immigration_data?.citizenship_status) {
            formDataObj.append("citizenship_status", formData.citizenship_status);
        }
        if (formData.awaiting_ead_card !== refetchedData.immigration_data?.awaiting_ead_card) {
            formDataObj.append("awaiting_ead_card", formData.awaiting_ead_card);
        }
        if (formData.ead_card_applied_date !== refetchedData.immigration_data?.ead_card_applied_date) {
            formDataObj.append("ead_card_applied_date", formData.ead_card_applied_date);
        }
        if (formData.citizenship_explanation !== refetchedData.immigration_data?.citizenship_explanation) {
            formDataObj.append("citizenship_explanation", formData.citizenship_explanation);
        }
        if (formData.legally_authorized_to_work !== refetchedData.immigration_data?.legally_authorized_to_work) {
            formDataObj.append("legally_authorized_to_work", formData.legally_authorized_to_work);
        }
        if (formData.ssn_issue_year !== refetchedData.immigration_data?.ssn_issue_year) {
            formDataObj.append("ssn_issue_year", formData.ssn_issue_year);
        }
        if (formData.work_authorization_expiry !== refetchedData.immigration_data?.work_authorization_expiry) {
            formDataObj.append("work_authorization_expiry", formData.work_authorization_expiry);
        }
        if (formData.renew_authorization_work !== refetchedData.immigration_data?.renew_authorization_work) {
            formDataObj.append("renew_authorization_work", formData.renew_authorization_work);
        }
        if (formData.i94_copy !== refetchedData.immigration_data?.i94_copy) {
            formDataObj.append("i94_copy", formData.i94_copy);
        }
        if (formData.passport_document !== refetchedData.immigration_data?.passport_document) {
            formDataObj.append("passport_document", formData.passport_document);
        }
        if (formData.proof_of_work_authorization !== refetchedData.immigration_data?.proof_of_work_authorization) {
            formDataObj.append("proof_of_work_authorization", formData.proof_of_work_authorization);
        }
    
        // Emergency contact data check and append
        if (formData.first_name1 !== refetchedData.emergency_contact?.first_name) {
            formDataObj.append("emergency_first_name", formData.first_name1);
        }
        if (formData.last_name1 !== refetchedData.emergency_contact?.last_name) {
            formDataObj.append("emergency_last_name", formData.last_name1);
        }
        if (formData.phone_number1 !== refetchedData.emergency_contact?.phone_number) {
            formDataObj.append("emergency_phone_number", formData.phone_number1);
        }
        if (formData.relation_type !== refetchedData.emergency_contact?.relation_type) {
            formDataObj.append("relation_type", formData.relation_type);
        }
    
        // Referral info check and append
        if (formData.referrer_name !== refetchedData.referral_info?.referrer_name) {
            formDataObj.append("referrer_name", formData.referrer_name);
        }
        if (formData.referral_phone_number !== refetchedData.referral_info?.referral_phone_number) {
            formDataObj.append("referral_phone_number", formData.referral_phone_number);
        }
        if (formData.referrer_relationship !== refetchedData.referral_info?.referrer_relationship) {
            formDataObj.append("referrer_relationship", formData.referrer_relationship);
        }

        // user_details check and append
        if (formData.placement_manager_id !== refetchedData.placement_manager_id) {
            formDataObj.append("placement_manager_id", formData.placement_manager_id);
        }
        if (formData.manager_id !== refetchedData.manager_id) {
            formDataObj.append("manager_id", formData.manager_id);
        }
        if (formData.is_employee !== refetchedData.is_employee) {
            formDataObj.append("is_employee", formData.is_employee);
        }
        if (formData.employee_id !== refetchedData.user_details?.employee_id) {
            formDataObj.append("employee_id", formData.employee_id);
        }
        if (formData.employment_type !== refetchedData.user_details?.employment_type) {
            formDataObj.append("employment_type", formData.employment_type);
        }
        if (formData.industry_start_date !== refetchedData.user_details?.industry_start_date) {
            formDataObj.append("industry_start_date", formData.industry_start_date);
        }
        if (formData.job_title !== refetchedData.user_details?.job_title) {
            formDataObj.append("job_title", formData.job_title);
        }


        // Marketing
        if (formData.is_csa !== refetchedData.user_details?.marketing?.is_csa) {
            formDataObj.append("is_csa", formData.is_csa);
        }
        if (formData.is_cad !== refetchedData.user_details?.marketing?.is_cad) {
            formDataObj.append("is_cad", formData.is_cad);
        }
        if (formData.is_csi !== refetchedData.user_details?.marketing?.is_csi) {
            formDataObj.append("is_csi", formData.is_csi);
        }
        if (formData.marketing_risk_level !== refetchedData.user_details?.marketing?.marketing_risk_level) {
            formDataObj.append("marketing_risk_level", formData.marketing_risk_level);
        }

        if (formData.linkedin_url !== refetchedData.user_details?.marketing?.linkedin_url) {
            formDataObj.append("linkedin_url", formData.linkedin_url);
        }
        if (formData.marketing_email !== refetchedData.user_details?.marketing?.marketing_email) {
            formDataObj.append("marketing_email", formData.marketing_email);
        }
        if (formData.marketing_email_pwd !== refetchedData.user_details?.marketing?.marketing_email_pwd) {
            formDataObj.append("marketing_email_pwd", formData.marketing_email_pwd);
        }
        if (formData.is_auto_farwards !== refetchedData.user_details?.marketing?.is_auto_farwards) {
            formDataObj.append("is_auto_farwards", formData.is_auto_farwards);
        }
        if (formData.marketing_account_recovery_email !== refetchedData.user_details?.marketing?.marketing_account_recovery_email) {
            formDataObj.append("marketing_account_recovery_email", formData.marketing_account_recovery_email);
        }
        if (formData.stage !== refetchedData.user_details?.marketing?.stage?.id) {
            formDataObj.append("stage_id", formData.stage);
        }
        if (formData.sub_stage !== refetchedData.user_details?.marketing?.sub_stage?.id) {
            formDataObj.append("sub_stage_id", formData.sub_stage);
        }
        if (formData.is_reset !== 0) {
            formDataObj.append("is_reset", formData.is_reset);
        }
        if(refetchedData?.user_details?.re_onboarding_status === true){
            if (formData.re_onboarding !== refetchedData.re_onboarding) {
                formDataObj.append("re_onboarding", formData.re_onboarding);
            }
        }

        training.forEach((item, index) => {
            formDataObj.append(`training_programs[${index}][program_id]`, item.program_id);
            formDataObj.append(`training_programs[${index}][status]`, programStatuses[item.program_id]);
        });
    
        
        for (let key of Array.from(formDataObj.keys())) {
            if (key === "marketing_risk_level") continue;
            
            const value = formDataObj.get(key);
            if (value === null || value === '' || value === 'null') {
                formDataObj.delete(key);
            }
        }

        if (opendataUsc) {
            formDataObj.delete('i94_copy');
            formDataObj.delete('laws_and_regulations');
        } else {
            formDataObj.delete('passport_document');
        }

    
        // Proceed with the API request
        const response = await apiService.postRequest(`/admin/jobseeker-update/${id}`, formDataObj, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    
        if (response && response.success === true) {
            setErrors("");
            setErrorMessage("");
            toast(response.message || "Updated Successfully");
            setEditMode(false);
            setPassfieldshows(false);
            fetchUserData();
            sessionStorage.removeItem('seekerEdit');
        }else{
            setErrorMessage(response.message);
            setErrors(response.errors || "");
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
    }catch (error) {
        console.log("err",error);
    }finally {
        setSubmitloader(false);
    }
    };
    const handleimpersonates = async () =>{
        try {
            const loginResponse = await apiService.postRequest('impersonate', {
                jobseeker_id: id,
            });
            if (loginResponse && loginResponse.success === true) {
                const session_warning = loginResponse.session_warning;
                const session_timeout = loginResponse.session_timeout;
                const expiryTime = Date.now() + session_timeout * 60 * 1000;
                const token = loginResponse.token;
                const user_type = loginResponse.user_type;
                const user_id = loginResponse.user_id;
                localStorage.setItem('token', token);
                localStorage.setItem("sessionExpiry", expiryTime.toString());
                localStorage.setItem("sessionWarning", session_warning.toString());
                localStorage.setItem('role', user_type);
                localStorage.setItem('userid', user_id);
                localStorage.setItem('impersonate', true);
                if (loginResponse && loginResponse?.pending_signup === true) {
                    switch (loginResponse?.pending_step) { 
                      case 'personal_questions':
                        navigate('/registration/personal-questions');
                        break;
                      case 'immigration':
                        navigate('/registration/immigration-questions'); 
                        break;
                      case 'emergency':
                        navigate('/registration/emergency-contact');
                        break;
                      default:
                        navigate('/registration/referral-information');
                    }
                } else{
                    navigate("/dashboard");
                }
                window.location.reload();
            }else{
                toast(loginResponse.message);
            }
        } catch (error) {
            console.log(error,"Failed. Please try again");
        }finally {
            setSubmitloader(false);
        }
    }
    const rows = profiles?.training_programs?.programs?.map((datas) => ({
        id: datas.program_id,
        programName: datas.program_name,
        status: datas.status,
        startedAt:datas.started_at,
        completedAt:datas.completed_at,
        // city:datas.city,
    }));
    const columns = [
        {
            field: 'programName',
            headerName: 'Program Name',
            minWidth: 450,
            flex: 1,
            filterable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 250,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span className='m-0 capssets'>{params.row.status}</span>
                </div>
            ),
            filterable: false
        },
        {
            field: 'startedAt',
            headerName: 'Started At',
            minWidth: 200,
            flex: 1,
            filterable: false,
        },
        {
            field: 'completedAt',
            headerName: 'Completed At',
            minWidth: 200,
            flex: 1,
            filterable: false,
        },
    ];

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
            return '#28a745';
            case 'suspend':
            case 'rejected':
            return '#d9283a';
            case 'pending':
            default:
            return '#1A5298';
        }
    };
return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:11.5}} container alignItems="center" justifyContent="center">
                    <Grid size={{md:12,xs:12}} container alignItems="center" justifyContent="space-between" flexDirection="row" className="jobseekerhead pt-3">
                        <Grid container flexDirection="column">
                            <h3>
                                {profiles?.format_id || "JOBSEEKER"}
                                {profiles?.recycle_status === true &&
                                    <span className='ms-2' style={{fontSize:'12px', fontWeight:'bold', color:'#fff', backgroundColor:'#d9283a', borderRadius:'12px', padding:'3px 10px', verticalAlign:'middle'}}>
                                        Recycle Bin
                                    </span>
                                }
                            </h3>
                            <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/jobseekers")}>Jobseekers</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {profiles.first_name}</span>
                        </Grid>
                        <Grid container justifyContent="flex-end" className="gap-3">
                            {!loading && <>
                            {permissionstest && permissionstest.manage_jobseeker_impersonator === true &&
                                <button onClick={handleimpersonates} className='registersendbtn2 my-0 px-4' style={{width:"max-content"}}>Impersonate</button>
                            }
                            {permissionstest && permissionstest.manage_jobseeker_writer !== true ? "" :<>
                            {profiles?.force_onboarded === 1 &&
                            <button style={{width:"max-content"}}
                                className='registersendbtn1 my-0 px-3'
                                onClick={() => setShowCasepop3(true)}
                            >
                                Continue Onboard
                            </button>}
                            {profiles.recycle_status !== true ?
                            <button style={{width:"max-content"}}
                                className='registersendbtn1 my-0 px-3'
                                onClick={() => setShowCasepop2(true)}
                            >
                                Move to Recycle
                            </button>:
                            <button
                                className='registersendbtn1 my-0'
                                onClick={() => setShowCasepop(true)}
                            >
                                {profiles.suspended === 0 ? "Lock" : "Unlock"}
                            </button>}
                            { !editMode ? 
                            <button className='back_buttonminus' onClick={()=>{ setEditMode(true); sessionStorage.setItem('seekerEdit', true);}}>Edit</button> :
                            <button className='back_buttonminus' onClick={()=>{ setEditMode(false); sessionStorage.removeItem('seekerEdit');}}>Cancel</button> }
                            </>}</>}
                            <button className='back_buttonminus' onClick={() => navigate("/user/jobseekers")}>Back</button>
                        </Grid>
                        {/* <span><b>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Jobseekers</span> */}
                    </Grid>
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <Grid size={{ lg: expanded ? 7.4 : 11.5, md: expanded ? 7 : 11, xs: 12 }} container sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} >
                            { !editMode ?
                            <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekers_profilealls my-4">
                                <Grid size={{xs:12}} container>
                                    <h4>Work Flow</h4>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Stage</span>
                                    <p className='capssets'>{profiles?.current_onboarding_stage}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Sub Stage</span>
                                    <p className='capssets'>{profiles?.current_onboarding_sub_stage}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Onboarding Case Status</span>
                                    <p className='capssets'>{profiles?.current_onboarding_status}</p>
                                </Grid>
                                {profiles?.onboarding_cases &&
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Onboarding Case Number</span>
                                    <div className='d-flex flex-wrap'>
                                        {profiles?.onboarding_cases?.map((item, index) => (
                                            <span className='me-1' key={item?.formatted_id}>
                                                <Link
                                                className='fw-bold text-decoration-none'
                                                style={{ color: getStatusColor(item?.status) }}
                                                to={item?.case_link}
                                                target='_blank'
                                                >
                                                {item?.formatted_id}
                                                </Link>
                                                {index < profiles.onboarding_cases?.length - 1 && <span>, </span>}
                                            </span>
                                            ))}
                                    </div>
                                </Grid>}
                                {refetchedData?.user_details?.re_onboarding_status === true &&
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Re Onboarding</span>
                                    <p className='capssets'>{refetchedData?.user_details?.re_onboarding === 1 ? "True" : "False"}</p>
                                    {/* <div className='d-flex align-items-center fw-bold main_radioregister'>
                                        <input
                                            type="checkbox"
                                            checked={refetchedData?.user_details?.re_onboarding === 1}
                                            disabled
                                        />Re Onboarding
                                    </div> */}
                                </Grid>}
                                {profiles?.current_groups && profiles.current_groups.length > 0 &&
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Member Of</span>
                                    <p className='capssets'>{profiles.current_groups.map((group) => group.name).join(', ')}</p>
                                </Grid>}
                                <Grid size={{xs:12}} container>
                                    <h4>Basic Informations</h4>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>First Name</span>
                                    <p>{profiles.first_name}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Last Name</span>
                                    <p>{profiles.last_name}</p>
                                </Grid>
                                <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Email Id</span>
                                    <p>{profiles.email}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Date of Birth</span>
                                    <p>{profiles.dob || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Gender</span>
                                    <p className='capssets'>{profiles.gender || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Address</span>
                                    <p className='capssets'>{profiles.address || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>City</span>
                                    <p className='capssets'>{profiles.city || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>State</span>
                                    <p className='capssets'>{profiles.state || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Zip Code</span>
                                    <p>{profiles.zipcode || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Phone Number</span>
                                    <p>{profiles.phone_number || "No data"}</p>
                                </Grid>
                                <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Why do you want to enroll with us?</span>
                                    <p className='capssets'>{profiles.why_enroll || "No data"}</p>
                                </Grid>
                                
                                <Grid size={{xs:12}} container flexDirection="column" className={`tab_classwidther ${ expanded && "control_splits"}`}>
                                {profiles2 && profiles2.length !== 0 &&
                                    <Tabs
                                        defaultActiveKey="immigration"
                                        id="uncontrolled-tab-example"
                                        className="mb-3 drafttabs_tabs"
                                        >
                                        <Tab eventKey="immigration" title="Immigration">
                                            {profiles2 && profiles2.length === 0 ? 
                                                <span className='text-center'>No data</span>:
                                                <Grid size={{xs:12}} container justifyContent="space-between">
                                                    <Grid size={{xs:12}} container>
                                                        <h4>Immigration Informations</h4>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Citizenship Status</span>
                                                        <p className='capssets'>{profiles2.citizenship_status}</p>
                                                    </Grid>
                                                    {profiles2.awaiting_ead_card && (
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Are you waiting for your EAD Card to Arrive?</span>
                                                        <p className='capssets'>{profiles2.awaiting_ead_card}</p>
                                                    </Grid>)}
                                                    {profiles2.ead_card_applied_date && (
                                                    <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>When did you apply for your EAD Card?</span>
                                                        <p className='capssets'>{profiles2.ead_card_applied_date}</p>
                                                    </Grid>)}
                                                    <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Explain your citizenship status</span>
                                                        <p className='capssets' style={{wordBreak: "break-word"}}>{profiles2.citizenship_explanation}</p>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Are you legally authorized to work in United States ?</span>
                                                        <p className='capssets'>{profiles2.legally_authorized_to_work}</p>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>When will your work authorization expire ?</span>
                                                        <p className='capssets'>{profiles2.work_authorization_expiry || "No data"}</p>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Which year was your SSN Issued ?</span>
                                                        <p className='capssets'>{profiles2.ssn_issue_year || "No data"}</p>
                                                    </Grid>
                                                    {profiles2 && profiles2.passport_document ?
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Upload Most Recent Passport Copy</span>
                                                        <a href={`${profiles2.passport_document}`} target="_blank" rel="noopener noreferrer">View</a>
                                                    </Grid>:<>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Upload Most Recent I94 Copy</span>
                                                        <a href={`${profiles2.i94_copy}`} target="_blank" rel="noopener noreferrer">View</a>
                                                    </Grid>
                                                    <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>I hereby authorize agents of TekPossible Consulting to access and verify the authenticity of my uploaded I-94 document through the official I-94 website (https://i94.cbp.dhs.gov/I94). I understand that this verification will be conducted in accordance with applicable laws and regulations.</span>
                                                        <p>Yes</p>
                                                    </Grid></>}
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Upload Proof of Work Authorization</span>
                                                        {profiles2 && profiles2.proof_of_work_authorization ?
                                                        <a href={`${profiles2.proof_of_work_authorization}`} target="_blank" rel="noopener noreferrer">View</a>
                                                        :" No data"}
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Upload Profile Picture</span>
                                                        {profiles && profiles.profile ?
                                                            <a href={`${profiles.profile}`} target="_blank" rel="noopener noreferrer">View</a>
                                                        :" No data"}
                                                    </Grid>
                                                </Grid>
                                            }
                                        </Tab>
                                        {profiles3 && profiles3.length !== 0 &&
                                            <Tab eventKey="emergency" title="Emergency">
                                            {profiles3 && profiles3.length === 0 ?
                                                <span className='text-center'>No data</span>:<Grid size={{xs:12}} container justifyContent="space-between">
                                                    <Grid size={{sm:12,xs:12}} container>
                                                        <h4>Emergency Contact</h4>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>First Name</span>
                                                        <p className='capssets'>{profiles3.first_name}</p>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Last Name</span>
                                                        <p className='capssets'>{profiles3.last_name}</p>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Phone Number</span>
                                                        <p className='capssets'>{profiles3.phone_number}</p>
                                                    </Grid>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Relationship</span>
                                                        <p className='capssets'>{profiles3.relation_type}</p>
                                                    </Grid>
                                                </Grid>}
                                            </Tab>
                                        }
                                        {profiles4 && profiles4.length !== 0 &&
                                            <Tab eventKey="referral" title="Referral">
                                                {profiles4 && profiles4.length === 0 ? 
                                                <span className='text-center'>No data</span>:<>
                                                <Grid size={{sm:12,xs:12}} container>
                                                    <h4>Referral Information</h4>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Referrer Phone Number</span>
                                                    <p className='capssets'>{profiles4.referral_phone_number}</p>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Referrer Name</span>
                                                    <p className='capssets'>{profiles4.referrer_name}</p>
                                                </Grid>
                                                <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>How do you know the referrer ?</span>
                                                    <p className='capssets'>{profiles4.referrer_relationship}</p>
                                                </Grid>
                                                </>}
                                            </Tab>
                                        }
                                        <Tab eventKey="employment" title="Employment">
                                            <Grid size={{xs:12}} container justifyContent="space-between">
                                                <Grid size={{sm:12,xs:12}} container>
                                                    <h4>Employment Profile</h4>
                                                </Grid>
                                                <Grid size={{xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Placement Manager</span>
                                                    <p className='capssets'>{profiles5?.placement_manager || "No Data"}</p>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Employee</span>
                                                    <p className='capssets'>{profiles.is_employee === 1 ? "Yes" : "No"}</p>
                                                </Grid>
                                                {profiles.is_employee === 1 && <>
                                                    <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                        <span>Employment Type</span>
                                                        <p className='capssets'>{profiles5.employment_type === "dallas_employee" ? "D-Employee" : "R-Employee"}</p>
                                                    </Grid>
                                                    {profiles5.employment_type === "dallas_employee" &&<>
                                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                            <span>Industry Start Date</span>
                                                            <p className='capssets'>{profiles5.industry_start_date || "No Data"}</p>
                                                        </Grid>
                                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                            <span>D-Employee ID</span>
                                                            <p className='capssets'>{profiles5.employee_id || "No Data"}</p>
                                                        </Grid>
                                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                            <span>D-Job Title</span>
                                                            <p className='capssets'>{profiles5.job_title || "No Data"}</p>
                                                        </Grid>
                                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                            <span>Onshore Manager</span>
                                                            <p className='capssets'>{selectedOnManager?.label || "No Data"}</p>
                                                        </Grid>
                                                    </>}
                                                </>}
                                            </Grid>
                                        </Tab>
                                        <Tab eventKey="marketing" title="Marketing">
                                            <Grid size={{xs:12}} container justifyContent="space-between">
                                                <Grid size={{sm:12,xs:12}} container>
                                                    <h4>Marketing</h4>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Certifications</span>
                                                    <p className="capssets mb-1">
                                                        {[ profiles5?.marketing?.is_cad === 1 && "CAD", profiles5?.marketing?.is_csa === 1 && "CSA", profiles5?.marketing?.is_csi === 1 && "CSI",]
                                                        .filter(Boolean)
                                                        .join(", ") || "No Data"}
                                                    </p>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Marketing Risk Level</span>
                                                    <p className='capssets'>{profiles5?.marketing?.marketing_risk_level || "No Data"}</p>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>LinkedIn URL</span>
                                                    {profiles5?.marketing?.linkedin_url ? 
                                                    <Link to={profiles5?.marketing?.linkedin_url} target='_blank'>View</Link>:
                                                    <p className='capssets'>No Data</p>}
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Marketing Email</span>
                                                    <p className='capssets'>{profiles5?.marketing?.marketing_email || "No Data"}</p>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Marketing A/C Recovery Email</span>
                                                    <p className='capssets'>{profiles5?.marketing?.marketing_account_recovery_email || "No Data"}</p>
                                                </Grid>
                                                <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Auto Forwards Setup</span>
                                                    <p className='capssets'>{profiles5?.marketing?.is_auto_farwards === 1 ? "true" : "false"}</p>
                                                </Grid>
                                            </Grid>
                                        </Tab>
                                        <Tab eventKey="training" title="Training">
                                            <Grid size={{xs:12}} container justifyContent="space-between">
                                                <Grid size={{sm:12,xs:12}} container>
                                                    <h4>Training</h4>
                                                </Grid>
                                                <Grid size={{xs:12}} container flexDirection="column" className="seekprof_borders">
                                                    <span>Overall Training Status</span>
                                                    <p className='capssets'>{profiles?.training_programs?.jobseeker_program_status || "No Data"}</p>
                                                </Grid>
                                                <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi select_searchindex">
                                                    <DataGrid
                                                        style={{minHeight:"200px"}}
                                                        rows={rows}
                                                        columns={columns}
                                                        disableSelectionOnClick
                                                        components={{ Toolbar: GridToolbar }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Tab>
                                    </Tabs>
                                }
                                </Grid>
                            </Grid>
                            :
                            <Grid size={{xs:12}} container>
                                <form className='w-100' 
                                onSubmit={handleSubmit}
                                >
                                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs">
                                        <h5>Work Flow</h5>
                                        {profiles?.current_onboarding_status !== "completed" ? <>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Stage</span>
                                            <input type='text' disabled value={profiles?.current_onboarding_stage}/>
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Sub Stage</span>
                                            <input type='text' disabled value={profiles?.current_onboarding_sub_stage}/>
                                        </Grid>
                                        </> :<>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Stage</span>
                                            <AsyncPaginate
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                loadOptions={loadOptions}
                                                value={selectedStages}
                                                additional={{
                                                    page: 1,
                                                }}
                                                debounceTimeout={300}
                                                onChange={handleStagesChange}
                                                isClearable
                                                cacheUniqs={[]}
                                                placeholder="Select..."
                                                reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]} 
                                            />
                                            {errors.stage_id && <p style={{color:"Red"}}>{errors.stage_id}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Sub Stage</span>
                                            <AsyncPaginate
                                                key={optionsKey}
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                loadOptions={loadOptionsSubtype}
                                                value={selectedSubStages}
                                                additional={{
                                                    page: 1,
                                                }}
                                                placeholder="Select..."
                                                debounceTimeout={300}
                                                onChange={handleSubStages}
                                                isClearable
                                                cacheUniqs={[]}  // ✅ This prevents reloading on menu open/close
                                                reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}  // ✅ Accumulate options
                                            />
                                            {errors.sub_stage_id && <p style={{color:"Red"}}>{errors.sub_stage_id}</p>}
                                        </Grid>
                                        <Grid size={{sm:12}} container flexDirection="column" className="mt-3">
                                            <div className='d-flex align-items-center fw-bold main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="is_reset"
                                                    checked={formData.is_reset === 1} 
                                                    onChange={handleInputChange} 
                                                />Reset Stage
                                            </div>
                                            {errors.is_reset && <p style={{color:"Red"}}>{errors.is_reset}</p>}
                                        </Grid>
                                        </>}
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Onboarding Case Status</span>
                                            <input className='capssets' type='text' disabled value={profiles?.current_onboarding_status}/>
                                        </Grid>
                                        {refetchedData?.user_details?.re_onboarding_status === true &&
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="mt-3 pt-4">
                                            <div className='d-flex align-items-center fw-bold main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="re_onboarding"
                                                    checked={formData.re_onboarding === 1}
                                                    onChange={handleInputChange} 
                                                />Re Onboarding
                                            </div>
                                            {errors.re_onboarding && <p style={{color:"Red"}}>{errors.re_onboarding}</p>}
                                        </Grid>}
                                        <h5>Basic Informations</h5>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>First Name<small className='red_starimpo'>*</small></span>
                                            <input
                                                type="text"
                                                name="first_name"
                                                value={formData.first_name}
                                                onChange={handleInputChange} 
                                                onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                            />
                                            {errors.first_name && <p style={{color:"Red"}}>{errors.first_name}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Last Name<small className='red_starimpo'>*</small></span>
                                            <input
                                                type="text"
                                                name="last_name"
                                                value={formData.last_name}
                                                onChange={handleInputChange} 
                                                onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                            />
                                            {errors.last_name && <p style={{color:"Red"}}>{errors.last_name}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Email<small className='red_starimpo'>*</small></span>
                                            <input value={formData.email} disabled/>
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container className="gap-3 pt-3">
                                            {showsPassfield === true ?
                                            <button type='button' style={{width:"max-content"}} className='registersendbtn1 px-4 mb-0' onClick={()=>setPassfieldshows(false)}>Cancel</button>
                                            :<button type='button' style={{width:"max-content"}} className='registersendbtn2 px-4 mb-0' onClick={()=>setPassfieldshows(true)}>Password Reset</button>
                                            }
                                        </Grid>
                                        {showsPassfield === true &&
                                        <Grid size={{xs:12}} container justifyContent="space-between">
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Password<small className='red_starimpo'>*</small></span>
                                                <div className='d-flex input_witheye'>
                                                    <input
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={handleInputChange}
                                                        type={passwordVisible ? 'text' : 'password'}
                                                        placeholder="Abcd123#"
                                                        style={{ width: '100%', paddingRight: '40px' }}
                                                    />
                                                    <button type="button" onClick={togglePasswordVisibility}>
                                                        {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                    </button>
                                                </div>
                                                {errors.password && <p style={{color:"Red"}}>{errors.password}</p>}
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Confirm Password<small className='red_starimpo'>*</small></span>
                                                <div className='d-flex input_witheye'>
                                                    <input
                                                        name='confirm_password'
                                                        value={formData.confirm_password}
                                                        onChange={handleInputChange}
                                                        type={passwordVisible2 ? 'text' : 'password'}
                                                        placeholder="Abcd123#"
                                                        style={{ width: '100%', paddingRight: '40px' }}
                                                    />
                                                    <button type="button" onClick={togglePasswordVisibility2}>
                                                        {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                    </button>
                                                </div>
                                                {errors.confirm_password && <p style={{color:"Red"}}>{errors.confirm_password}</p>}
                                            </Grid>
                                        </Grid>}
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Date of Birth<small className='red_starimpo'>*</small></span>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        className="date_pickermux"
                                                        value={value}
                                                        onChange={handleDateChange}
                                                        maxDate={dayjs().subtract(18, 'year').subtract(1, 'day')}
                                                        renderInput={(params) => <input {...params} />}
                                                    />
                                                </LocalizationProvider>
                                                {errors.dob && <p style={{color:"Red"}}>{errors.dob}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Gender<small className='red_starimpo'>*</small></span>
                                            <select name="gender" 
                                            value={formData.gender}
                                            onChange={handleInputChange} 
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="prefer_not_to_answer">Prefer not to answer</option>
                                            </select>
                                            {errors.gender && <p style={{color:"Red"}}>{errors.gender}</p>}
                                        </Grid>
                                        <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                            <span>Address<small className='red_starimpo'>*</small></span>
                                            <input type="text" name="address"
                                                value={formData.address}
                                                onChange={handleInputChange}
                                            />
                                            {errors.address && <p style={{color:"Red"}}>{errors.address}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>State<small className='red_starimpo'>*</small></span>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                defaultValue={null}
                                                name="state"
                                                value={selectedState}
                                                options={states.map((state) => ({
                                                    label: state.name,
                                                    value: state.state_code,
                                                }))}
                                                onChange={handleStateChange}
                                            />
                                            {errors.state && <p style={{color:"Red"}}>{errors.state}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>City<small className='red_starimpo'>*</small></span>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                defaultValue={null}
                                                value={selectedCity}
                                                name="city"
                                                options={cities.map((city) => ({
                                                    label: city.city_name,
                                                    value: city.city_name,
                                                }))}
                                                onChange={handleCityChange}
                                            />
                                            {errors.city && <p style={{color:"Red"}}>{errors.city}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Zip Code<small className='red_starimpo'>*</small></span>
                                            <input type="text" name="zipcode"
                                                value={formData.zipcode}
                                                minLength="5" maxLength="9"
                                                onChange={handleInputChange} 
                                            onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                            {errors.zipcode && <p style={{color:"Red"}}>{errors.zipcode}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Phone Number<small className='red_starimpo'>*</small></span>
                                            <input
                                                type="text"
                                                name="phone_number"
                                                value={formData.phone_number}
                                                onChange={handlePhoneNumberChange}
                                                placeholder="***_***_****"
                                                maxLength="14" // To ensure no extra characters
                                                className={errors.phone_number ? 'input-error' : ''}
                                            />
                                            {errors.phone_number && <p style={{color:"Red"}}>{errors.phone_number}</p>}
                                        </Grid>
                                        
                                        <h5>Immigration Questions</h5>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Citizenship Status<small className='red_starimpo'>*</small></span>
                                            <select name="citizenship_status" 
                                            onChange={handleInputChange} 
                                            value={formData.citizenship_status}
                                            >
                                                <option value="" disabled>Select Citizenship Status</option>
                                                {citizenshipStatuses.map((status) => (
                                                <option key={status.id} value={status.status}>
                                                    {status.status}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.citizenship_status && <p style={{color:"Red"}}>{errors.citizenship_status}</p>}
                                        </Grid>
                                        {opendata &&
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Are you waiting for your EAD Card to Arrive?<small className='red_starimpo'>*</small></span>
                                            <select name="awaiting_ead_card" value={formData.awaiting_ead_card} 
                                            onChange={handleInputChange} 
                                            >
                                                <option value="" disabled>Select</option>
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </select>
                                            {errors.awaiting_ead_card && <p style={{color:"Red"}}>{errors.awaiting_ead_card}</p>}
                                        </Grid>
                                        }
                                        {opendata2 &&
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>When did you apply for your EAD Card?<small className='red_starimpo'>*</small></span>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className="date_pickermux"
                                                    value={value2}
                                                    onChange={handleDateChange1}
                                                    maxDate={dayjs(maxDate)}
                                                    renderInput={(params) => <input {...params} />}
                                                />
                                            </LocalizationProvider>
                                            {errors.ead_card_applied_date && <p style={{color:"Red"}}>{errors.ead_card_applied_date}</p>}
                                        </Grid>
                                        }
                                        <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                            <span>Explain your citizenship status<small className='red_starimpo'>*</small></span>
                                            <textarea placeholder='Describe' rows="10" name="citizenship_explanation" value={formData.citizenship_explanation} 
                                            onChange={handleInputChange}
                                            />
                                            {errors.citizenship_explanation && <p style={{color:"Red"}}>{errors.citizenship_explanation}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Are you legally authorized to work in United States ?<small className='red_starimpo'>*</small></span>
                                            <select name="legally_authorized_to_work" value={formData.legally_authorized_to_work} 
                                            onChange={handleInputChange}
                                            >
                                                <option value="" disabled>Select</option>
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </select>
                                            {errors.legally_authorized_to_work && <p style={{color:"Red"}}>{errors.legally_authorized_to_work}</p>}
                                        </Grid>
                                        {opendata3 &&
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>When will your work authorization expire ?<small className='red_starimpo'>*</small></span>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className="date_pickermux"
                                                    value={value1}
                                                    onChange={handleDateChange2}
                                                    minDate={dayjs(maxDate)}
                                                    renderInput={(params) => <input {...params} />}
                                                />
                                            </LocalizationProvider>
                                            {errors.work_authorization_expiry && <p style={{color:"Red"}}>{errors.work_authorization_expiry}</p>}
                                        </Grid>
                                        }
                                        {opendata4 &&
                                        <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                            <span>What actions have you taken or are planning to take to renew your Work Authorization?<small className='red_starimpo'>*</small></span>
                                            <textarea placeholder='Describe' rows="10" name="renew_authorization_work"
                                                value={formData.renew_authorization_work}
                                                onChange={handleInputChange}
                                                />
                                            {errors.renew_authorization_work && <p style={{color:"Red"}}>{errors.renew_authorization_work}</p>}
                                        </Grid>
                                        }
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Which year was your SSN Issued ?<small className='red_starimpo'>*</small></span>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker className="date_pickermux" views={[ 'year']} maxDate={dayjs(maxDate)} value={value3}
                                                    onChange={handleDateChange3} 
                                                    renderInput={(params) => <input {...params} />}/>
                                            </LocalizationProvider>
                                            {errors.ssn_issue_year && <p style={{color:"Red"}}>{errors.ssn_issue_year}</p>}
                                        </Grid>
                                    {opendataUsc &&
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Upload Most Recent Passport Copy<br/><small>(Upload only .jpg, .jpeg, .png, .pdf, .doc, .docx and with Maximum size as 5MB)</small><small className='red_starimpo'>*</small></span>
                                            <div className="fileUploadInput">
                                            <input
                                                type="file"
                                                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" 
                                                name="passport_document"
                                                id="passport_document"
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }} // Hide the actual file input
                                            />
                                            <label htmlFor="passport_document" style={{ cursor: 'pointer' }}>Upload</label>
                                            <input
                                                type="text"
                                                value={fileNames.passport_document || ''}
                                                readOnly
                                                placeholder="No file chosen"
                                            />
                                        </div>
                                            {errors.passport_document && <p style={{color:"Red"}}>{errors.passport_document[0]}</p>}
                                        </Grid>}
                                        {!opendataUsc && <>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Upload Most Recent I94 Copy<small className='red_starimpo'>*</small></span>
                                            <div className="fileUploadInput">
                                                <input
                                                    type="file"
                                                    name="i94_copy"
                                                    id="i94_copy"
                                                    onChange={handleFileChange}
                                                    style={{ display: 'none' }} // Hide the actual file input
                                                />
                                                <label htmlFor="i94_copy" style={{ cursor: 'pointer' }}>Upload</label>
                                                <input
                                                    type="text"
                                                    value={fileNames.i94_copy || ''}
                                                    readOnly
                                                    placeholder="No file chosen"
                                                />
                                            </div>
                                            {errors.i94_copy && <p style={{color:"Red"}}>{errors.i94_copy}</p>}
                                        </Grid>
                                        <Grid size={{sm:12}} container className="my-3" flexDirection="column">
                                            <span>I hereby authorize agents of TekPossible Consulting to access and verify the authenticity of my uploaded I-94 document through the official I-94 website (<a href="https://i94.cbp.dhs.gov/I94" target="_blank" rel="noopener noreferrer">https://i94.cbp.dhs.gov/I94</a>). I understand that this verification will be conducted in accordance with applicable laws and regulations.<small className='red_starimpo'>*</small></span>
                                            <div className='d-flex align-items-center main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="laws_and_regulations"
                                                    checked={formData.laws_and_regulations} 
                                                    onChange={handleInputChange} 
                                                />I agree
                                            </div>
                                            {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>}
                                        </Grid></>}
                                        {!opendata2 &&
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Upload Proof of Work Authorization<small className='red_starimpo'>*</small></span>
                                                <div className="fileUploadInput">
                                                    <input
                                                        type="file"
                                                        id="proof_of_work_authorization"
                                                        name="proof_of_work_authorization"
                                                        onChange={handleFileChange}
                                                        style={{ display: 'none' }} // Hide the actual file input
                                                    />
                                                    <label htmlFor="proof_of_work_authorization" style={{ cursor: 'pointer' }}>Upload</label>
                                                    <input
                                                        type="text"
                                                        value={fileNames.proof_of_work_authorization || ''}
                                                        readOnly
                                                        placeholder="No file chosen"
                                                    />
                                                </div>
                                                {errors.proof_of_work_authorization && <p style={{color:"Red"}}>{errors.proof_of_work_authorization}</p>}
                                            </Grid>
                                        }
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Upload Profile Picture</span>
                                            <div className="fileUploadInput">
                                            <input
                                                type="file"
                                                id="profile"
                                                name="profile"
                                                accept="image/png, image/gif, image/jpeg"
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }}
                                            />
                                            <label htmlFor="profile" style={{ cursor: 'pointer' }}>Upload</label>
                                            <input
                                                type="text"
                                                value={fileNames.profile || ''}
                                                readOnly
                                                placeholder="No file chosen"
                                            />
                                        </div>
                                        
                                        </Grid>
                                        <h5>Emergency Contact</h5>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>First Name<small className='red_starimpo'>*</small></span>
                                            <input type='text' name="first_name1" 
                                                value={formData.first_name1}
                                                onChange={handleInputChange} 
                                                onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                            />
                                            {errors.first_name1 && <p style={{color:"Red"}}>{errors.first_name1}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Last Name<small className='red_starimpo'>*</small></span>
                                            <input type='text' name="last_name1" 
                                            value={formData.last_name1}
                                            onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                            />
                                            {errors.last_name1 && <p style={{color:"Red"}}>{errors.last_name1}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Phone Number<small className='red_starimpo'>*</small></span>
                                            <input
                                                type="text"
                                                name="phone_number1"
                                                value={formData.phone_number1}
                                                onChange={handlePhoneNumberChange1}
                                                placeholder="***_***_****"
                                                maxLength="14" // To ensure no extra characters
                                                className={errors.phone_number1 ? 'input-error' : ''}
                                            />
                                            {errors.phone_number1 && <p style={{color:"Red"}}>{errors.phone_number1}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Relationship<small className='red_starimpo'>*</small></span>
                                            <select name="relation_type" 
                                                value={formData.relation_type}
                                            onChange={handleInputChange}
                                            >
                                                <option value="" disabled>Select</option>
                                                {relationships.map((relationship) => (
                                                    <option key={relationship.id} value={relationship.value}>
                                                    {relationship.value}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.relation_type && <p style={{color:"Red"}}>{errors.relation_type}</p>}
                                        </Grid>
                                        <h5>Referral information</h5>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Referrer Phone Number<small className='red_starimpo'>*</small></span>
                                            <PhoneInput
                                                className='phone_input_imgs'
                                                placeholder="Enter phone number"
                                                defaultCountry="US"
                                                countries={allowedCountries}
                                                international={false}
                                                limitMaxLength={true}
                                                value={formData.referral_phone_number}
                                                onChange={handlePhoneChange}
                                                onKeyDown={handleKeyDown2}
                                                autoComplete="new-password"
                                            />
                                            {errors.referral_phone_number && <p style={{color:"Red"}}>{errors.referral_phone_number}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Referrer Name<small className='red_starimpo'>*</small></span>
                                            <input type='text' name="referrer_name" 
                                            value={formData.referrer_name}
                                                onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                            />
                                            {errors.referrer_name && <p style={{color:"Red"}}>{errors.referrer_name}</p>}
                                        </Grid>
                                        <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                            <span>How do you know the referrer ?<small className='red_starimpo'>*</small></span>
                                            <select name="referrer_relationship" 
                                            value={formData.referrer_relationship}
                                                onChange={handleInputChange}
                                            >
                                            <option value="" disabled>Select Referrer</option>
                                            {referrers.map((referrer) => (
                                                <option key={referrer.id} value={referrer.value}>
                                                {referrer.value}
                                                </option>
                                            ))}
                                            </select>
                                            {errors.referrer_relationship && <p style={{color:"Red"}}>{errors.referrer_relationship}</p>}
                                        </Grid>
                                        <h5>Employment Profile</h5>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Placement Manager ?<small className='red_starimpo'>*</small></span>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                defaultValue={null}
                                                name="placement_manager_id"
                                                value={selectedManager}
                                                options={mangerList.map((mangerList) => ({
                                                    label: mangerList.name,
                                                    value: mangerList.id,
                                                }))}
                                                onChange={handleManagerChange}
                                            />
                                            {errors.placement_manager_id && <p style={{color:"Red"}}>{errors.placement_manager_id}</p>}
                                        </Grid>
                                        <Grid size={{sm:12}} container flexDirection="column" className="mt-3">
                                            <div className='d-flex align-items-center fw-bold main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="is_employee"
                                                    checked={formData.is_employee === 1} 
                                                    onChange={handleInputChange} 
                                                />Employee
                                            </div>
                                            {errors.employee && <p style={{color:"Red"}}>{errors.employee}</p>}
                                        </Grid>
                                        {formData.is_employee === 1 && <>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Employment Type<small className='red_starimpo'>*</small></span>
                                                <select name="employment_type" value={formData.employment_type} onChange={handleInputChange} >
                                                    <option value="" disabled>Select Employment Type</option>
                                                    <option value="dallas_employee">D-Employee</option>
                                                    <option value="revenue_employee">R-Employee</option>
                                                </select>
                                                {errors.employment_type && <p style={{color:"Red"}}>{errors.employment_type}</p>}
                                            </Grid>
                                            {formData.employment_type === "dallas_employee" &&<>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Industry Start Date<small className='red_starimpo'>*</small></span>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        className="date_pickermux"
                                                        value={value4}
                                                        onChange={handleDateChange4}
                                                        maxDate={dayjs()}
                                                        renderInput={(params) => <input {...params} />}
                                                    />
                                                </LocalizationProvider>
                                                {errors.industry_start_date && <p style={{color:"Red"}}>{errors.industry_start_date}</p>}
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>D-Employee ID<small className='red_starimpo'>*</small></span>
                                                <input type='text' name="employee_id" value={formData.employee_id} onChange={handleInputChange} 
                                                // onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                                />
                                                {errors.employee_id && <p style={{color:"Red"}}>{errors.employee_id}</p>}
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>D-Job Title<small className='red_starimpo'>*</small></span>
                                                <input type='text' name="job_title" value={formData.job_title} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                                                {errors.job_title && <p style={{color:"Red"}}>{errors.job_title}</p>}
                                            </Grid></>}
                                            {formData.employment_type === "dallas_employee" && 
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Onshore Manager ?<small className='red_starimpo'>*</small></span>
                                                <Select
                                                    className="basic-single select_withsearch"
                                                    classNamePrefix="select"
                                                    defaultValue={null}
                                                    name="manager_id"
                                                    value={selectedOnManager}
                                                    options={mangerList.map((mangerList) => ({
                                                        label: mangerList.name,
                                                        value: mangerList.id,
                                                    }))}
                                                    onChange={handleOnshoreManagerChange}
                                                />
                                                {errors.manager_id && <p style={{color:"Red"}}>{errors.manager_id}</p>}
                                            </Grid>
                                            }
                                        </>}

                                        <h5>Marketing</h5>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Certifications</span>
                                            <div className='d-flex align-items-center fw-bold main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="is_csa"
                                                    checked={formData.is_csa === 1} 
                                                    onChange={handleInputChange} 
                                                />CSA
                                            </div>
                                            {errors.is_csa && <p style={{color:"Red"}}>{errors.is_csa}</p>}
                                            <div className='d-flex align-items-center fw-bold main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="is_cad"
                                                    checked={formData.is_cad === 1} 
                                                    onChange={handleInputChange} 
                                                />CAD
                                            </div>
                                            {errors.is_cad && <p style={{color:"Red"}}>{errors.is_cad}</p>}
                                            <div className='d-flex align-items-center fw-bold main_radioregister'>
                                                <input
                                                    type="checkbox" 
                                                    name="is_csi"
                                                    checked={formData.is_csi === 1} 
                                                    onChange={handleInputChange} 
                                                />CSI
                                            </div>
                                            {errors.is_csi && <p style={{color:"Red"}}>{errors.is_csi}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Marketing Risk Level</span>
                                            <select name="marketing_risk_level" value={formData.marketing_risk_level} onChange={handleInputChange}>
                                                <option value="">Select Risk Level</option>
                                                <option value="safe">Safe</option>
                                                <option value="risky">Risky</option>
                                            </select>
                                            {errors.marketing_risk_level && <p style={{color:"Red"}}>{errors.marketing_risk_level}</p>}
                                        </Grid>

                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>LinkedIn URL</span>
                                            <input value={formData.linkedin_url} name="linkedin_url" type='url' onChange={handleInputChange}/>
                                            {errors.linkedin_url && <p style={{color:"Red"}}>{errors.linkedin_url}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Marketing Email</span>
                                            <input autoComplete="new-password" name="marketing_email" value={formData.marketing_email} type='email' onChange={handleInputChange}/>
                                            {errors.marketing_email && <p style={{color:"Red"}}>{errors.marketing_email}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Marketing Email Pwd</span>
                                            <div className='d-flex input_witheye'>
                                                <input
                                                    name="marketing_email_pwd"
                                                    value={formData.marketing_email_pwd}
                                                    onChange={handleInputChange}
                                                    autoComplete="new-password"
                                                    type={passwordVisible3 ? 'text' : 'password'}
                                                    placeholder="Abcd123#"
                                                    style={{ width: '100%', paddingRight: '40px' }}
                                                />
                                                <button type="button" onClick={togglePasswordVisibility3}>
                                                    {passwordVisible3 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </button>
                                            </div>
                                            {errors.marketing_email_pwd && <p style={{color:"Red"}}>{errors.marketing_email_pwd}</p>}
                                        </Grid>
                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Marketing A/C Recovery Email</span>
                                            <input autoComplete="new-password" name="marketing_account_recovery_email" onChange={handleInputChange} value={formData.marketing_account_recovery_email} type='email'/>
                                            {errors.marketing_account_recovery_email && <p style={{color:"Red"}}>{errors.marketing_account_recovery_email}</p>}
                                        </Grid>
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <div className='d-flex align-items-center fw-bold main_radioregister mt-3'>
                                                <input
                                                    type="checkbox" 
                                                    name="is_auto_farwards" 
                                                    checked={formData.is_auto_farwards === 1} 
                                                    onChange={handleInputChange} 
                                                />Auto Forwards Setup
                                            </div>
                                            {errors.is_auto_farwards && <p style={{color:"Red"}}>{errors.is_auto_farwards}</p>}
                                        </Grid>

                                        <h5>Training</h5>
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Overall Training Status</span>
                                            <p className='capssets'>{profiles?.training_programs?.jobseeker_program_status || "No Data"}</p>
                                        </Grid>
                                        <Grid size={{xs:12}} container justifyContent="space-between">
                                        {training.map(item => (
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>{item?.program_name}</span>
                                                <select
                                                    key={item.program_id}
                                                    value={programStatuses[item.program_id]}
                                                    onChange={(e) => handleStatusChange(item.program_id, e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="pending">Pending</option>
                                                    <option value="in-progress">In Progress</option>
                                                    <option value="completed">Completed</option>
                                                    <option value="failed">Failed</option>
                                                    <option value="skipped">Skipped</option>
                                                </select>
                                            </Grid>
                                        ))}
                                        </Grid>
                                        {errors.training_programs && <p style={{color:"Red"}}>{errors.training_programs}</p>}

                                        {errorMessage && <p style={{ color: 'red', width:"100%", marginTop:"15px" }}>{errorMessage}</p>}
                                        <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="mt-2 gap-3">
                                        <button type='submit' className='registersendbtn2'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                                        { editMode ? 
                                            <button className='registersendbtn1' onClick={()=> setEditMode(false)}>Cancel</button> :""
                                        }
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid>}</Grid>
                            <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 4.8 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                                <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                                    {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                                </button>
                                <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                                    <DiscussionsSeeker/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{xs:12}} container flexDirection="column" className="py-5">
                        <Tabs
                            defaultActiveKey="attachments"
                            onSelect={(key) => setActiveTab(key)}
                            id="uncontrolled-tab"
                            className="mb-3 drafttabs_tabs"
                            >
                            <Tab eventKey="attachments" title="Attachments">
                                {activeTab === "attachments" && <AttachmentsSeeker />}
                            </Tab>
                            <Tab eventKey="relatedcases" title="Raised Cases">
                                {activeTab === "relatedcases" && <RaisedCasesSeekerComp />}
                            </Tab>
                            <Tab eventKey="recentviewjobs" title="Recently Viewed Jobs">
                                {activeTab === "recentviewjobs" && <RecentViewJobsSeeker />}
                            </Tab>
                            <Tab eventKey="recentapplyjobs" title="Recently Applied Jobs">
                                {activeTab === "recentapplyjobs" && <RecentApplyJobsSeeker />}
                            </Tab>
                            <Tab eventKey="activitytimeline" title="Activity History">
                                {activeTab === "activitytimeline" && <ActivityTimeline />}
                            </Tab>
                        </Tabs>
                        </Grid>
                        </>
                    }
                </Grid>
            </Grid>
            <Modal
                show={showCasepop} 
                onHide={handleCloseCase}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    {profiles?.suspended === 0 ? 
                    <small className='fw-bold'>After locking this candidate, they will no longer be able to access the platform.</small>:
                    <small className='fw-bold'>After unlocking this candidate, they will be able to access the platform again.</small>
                    }
                    <p>Are you sure you want to change the status to{" "}<strong className='uppercasers'>{profiles?.suspended === 1 ? "Unlock" : "Lock"}</strong>?</p>
                    {/* <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div> */}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={() => handleSuspend(id, profiles.suspended === 1)}>
                    {loadingCase ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showCasepop2} 
                onHide={handleCloseCase2}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    <small className='fw-bold'>If you move this candidate to the Recycle stage, the associated onboarding case will be suspended. Once suspended, you will not be able to continue working on the suspended case.</small>
                    <p>Are you sure you want to change this jobseeker to <strong className='uppercasers'>Recycle Stage</strong></p>
                    {/* <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div> */}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase2}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={() => handleRecycle(id)}>
                    {loadingCase2 ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showCasepop3} 
                onHide={handleCloseCase3}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    <p>Are you sure you want to <strong className='uppercasers'>Continue Onboarding</strong> with this jobseeker </p>
                    {/* <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div> */}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase3}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={() => handleOnboard(id)}>
                    {loadingCase3 ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default JobseekerFormDetails
